/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MyMarkdownComponent = ({ msg }: any) => {
  // Clean the message content before passing to ReactMarkdown
  return (
    <div className="react-markdown">
      <ReactMarkdown
        children={msg}
        remarkPlugins={[remarkGfm]} // Include remark-gfm plugin
        components={{
          // Customize rendering of <h3>
          h3: ({ children }) => <h3>{children}</h3>,
          // Customize rendering of <p>
          p: ({ children }) => <p>{children}</p>,
          // Customize rendering of <ul> and <li>
          ul: ({ children }) => <ul>{children}</ul>,
          li: ({ children }) => <li>{children}</li>,
          // Customize rendering of <img>
          img: ({ src, alt }) => (
            <img
              src={src}
              alt={alt}
              style={{
                display: "block",
                margin: "0",
                padding: "0",
                maxWidth: "100%",
              }}
            />
          ),
          // Customize rendering of <pre> and <code>
          pre: ({ children }) => (
            <pre style={{ margin: "0", padding: "0.5rem", whiteSpace: "pre-wrap" }}>{children}</pre>
          ),
          code: ({ children }) => (
            <code style={{ fontFamily: "monospace", fontSize: "0.9rem" }}>{children}</code>
          ),
          // Wrap tables in a div with overflow-x-auto
          table: ({ children }) => (
            <div className="overflow-x-auto scroll-bar">
              <table className="min-w-full mb-1">{children}</table>
            </div>
          ),
        }}
      />
    </div>
  );
};

export default MyMarkdownComponent;
